
import styled from '@emotion/styled'
import { mainColor600 } from '../model/themeColor'

// todo
export const TitleText = styled.span`
  text-align: left;  
  font-family: Roboto;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;  
  letter-spacing: -0.05em;
  color: ${() => mainColor600};
`

export const ContentText = styled.span`
  text-align: left;  
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;  
  letter-spacing: -0.05em;
  color: #040404;  
`
export const ButtonStyle = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontSize: '13px',
  fontWeight: 700,
  border: '1px solid #cccccc',
  color: mainColor600,
  height: '32px'
}